export default "__VITE_ASSET__DIrWVj0Y__"